import React from "react";
import { Loader } from "semantic-ui-react";

export const LoadingArt = () => <Loader active inline="centered" />;
